module.exports = __webpack_public_path__ + "img/trapezoid.c3747bc6.svg";